// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type BulletedList20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const BulletedList20: FC<BulletedList20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M7.5 15v-1.5H17V15H7.5Zm0-4.25v-1.5H17v1.5H7.5Zm0-4.25V5H17v1.5H7.5Zm-3.004 9.25c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 0 1 3 14.246c0-.414.147-.767.442-1.059a1.456 1.456 0 0 1 1.062-.437c.414 0 .767.147 1.059.442.291.294.437.649.437 1.062 0 .414-.147.767-.442 1.059a1.456 1.456 0 0 1-1.062.437Zm0-4.25c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 0 1 3 9.996c0-.414.147-.767.442-1.059A1.456 1.456 0 0 1 4.504 8.5c.414 0 .767.147 1.059.442.291.294.437.649.437 1.062 0 .414-.147.767-.442 1.059a1.456 1.456 0 0 1-1.062.437Zm0-4.25c-.414 0-.767-.147-1.059-.442A1.456 1.456 0 0 1 3 5.746c0-.414.147-.767.442-1.059a1.456 1.456 0 0 1 1.062-.437c.414 0 .767.147 1.059.442.291.294.437.649.437 1.062 0 .414-.147.767-.442 1.059a1.456 1.456 0 0 1-1.062.437Z" />
        </svg>
    );
};

export default BulletedList20;
